// Golfer identity formatting (initials, full name, handicap index) for the wizard and results.

// "John Smith" -> "JS"; single-word names fall back to their first two letters.
export const memberInitials = (name) => {
  // Slice the TRIMMED value, or a whitespace-only name puts two blanks in the avatar.
  const trimmed = (name || '').trim()
  const parts = trimmed.split(/\s+/)
  if (parts.length === 1) { return trimmed.slice(0, 2).toUpperCase() }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

// Plus handicaps keep their sign ("+2.4"), others render unsigned to one decimal; null when empty.
export const formatHandicap = (val) => {
  if (val === null || val === undefined) { return null }
  const n = parseFloat(val)
  if (isNaN(n)) { return null }
  const rounded = parseFloat(n.toFixed(1))
  return rounded > 0 ? `+${rounded.toFixed(1)}` : Math.abs(rounded).toFixed(1)
}

// TMS API payloads carry either a composed `name` or the two name parts.
export const playerFullName = (player) =>
  player.name || `${player.first_name || ''} ${player.last_name || ''}`.trim()

// First-then-last even when the display name is stored last-first (RTM-10077), so parts come first.
export const initialsFromParts = (firstName, lastName, fallbackName) => {
  const first = (firstName || '').trim()
  const last = (lastName || '').trim()
  const initials = ((first[0] || '') + (last[0] || '')).toUpperCase()
  return initials || memberInitials(fallbackName || '')
}

// Initials for a player/blind payload (which carries first_name/last_name alongside name).
export const playerInitials = (player = {}) =>
  initialsFromParts(player.first_name, player.last_name, playerFullName(player))

// A foursome's seats in order: player, blind draw (tagged, with a synthetic id) or empty.
export const buildSlots = (players, blinds, maxSize) =>
  Array.from({ length: maxSize }, (_, i) => {
    const player = players.find((p) => p.position === i)
    if (player) { return player }
    const blind = blinds.find((b) => b.position === i)
    if (blind) { return { ...blind, _type: 'blind', player_round_id: `blind-${blind.blind_id}` } }
    return null
  })
